import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, unref as _unref } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "d-flex align-center gap-3"
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "cursor-pointer"
};
const _hoisted_8 = {
  class: "cursor-pointer"
};
const _hoisted_9 = {
  class: "cursor-pointer"
};
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-center"
};
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-center"
};
const _hoisted_12 = {
  key: 2,
  class: "d-flex align-center"
};
const _hoisted_13 = {
  class: "cursor-pointer"
};
const _hoisted_14 = {
  class: "cursor-pointer"
};
const _hoisted_15 = {
  key: 0,
  class: "mt-8 ml-4 mb-4"
};
const _hoisted_16 = {
  class: "cursor-pointer"
};
const _hoisted_17 = {
  class: "cursor-pointer"
};
const _hoisted_18 = {
  class: "cursor-pointer"
};
const _hoisted_19 = {
  class: "cursor-pointer"
};
const _hoisted_20 = {
  class: "cursor-pointer"
};
const _hoisted_21 = {
  class: "cursor-pointer"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  class: "cursor-pointer"
};
const _hoisted_25 = {
  class: "cursor-pointer"
};
const _hoisted_26 = {
  class: "cursor-pointer"
};
const _hoisted_27 = {
  class: "cursor-pointer"
};
const _hoisted_28 = {
  class: "cursor-pointer"
};
const _hoisted_29 = {
  class: "d-flex align-center border border-error rounded bg-[rgba(var(--v-theme-error),0.08)] pa-4 mt-6"
};
const _hoisted_30 = {
  class: "d-flex align-center"
};
const _hoisted_31 = {
  class: "overflow-auto h-full"
};
const _hoisted_32 = {
  class: "overflow-auto h-full"
};
import { onMounted, reactive, computed, ref } from 'vue';
import MainHeader from '@/components/MainHeader.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import { useCompanyBillingStore } from './companyBillingStore.js';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import RouteService from '@/services/RouteService';
import Loader from '@/components/Loader.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import ProductNotice from '@/components/ProductNotice.vue';
import SetUpExpensesDialogs from './SetUpExpensesDialogs.vue';
import Wizard from './Wizard.vue';
import { useExpenseSettingStore } from './expenseSettingStore.js';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlButtonToggle from '@/components/LlButtonToggle.vue';
import ClassTrackingSetup from '../../company/ClassTrackingSetup.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
const __default__ = {
  name: 'CompanyBilling',
  uiView: 'edit'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getSupportUrl
    } = useSupportChat();
    const {
      handleError
    } = useSnackbarHandler();
    const qboIntegrationUrl = computed(() => getSupportUrl('qboIntegration'));
    const props = __props;
    const originalForm = ref({});
    const companyBillingState = reactive({
      me: {
        features: {}
      },
      company: {},
      loading: false,
      form: {
        accountingService: {},
        clientBilling: {},
        createAccountingClients: false,
        paymentOptions: {
          creditCard: false,
          ach: false
        },
        taxcode: null,
        taxcodes: [],
        allowChange: false,
        billClient: true,
        billWithParent: false,
        distributionBillNumber: false,
        allowChangeValue: false,
        distributionMethod: null,
        distribution: {},
        operatingAccount: {},
        syncClientsFromAccounting: false
      },
      tax: {},
      openRealmConflictDialog: false,
      originalCompany: {},
      accounts: [],
      distributionMethod: [{
        label: 'Bill Vendor',
        id: 'billVendor'
      }],
      distributionAccounts: [],
      accountingServices: [],
      openSetUpExpensesDialog: false,
      unsaved: false,
      saving: false,
      routeService: undefined,
      openExpenseModal: false,
      openWizardDialog: false,
      showClassTrackingModal: false,
      currentExpenseSettingsStep: 0,
      currentExpenseSettingsTitle: '',
      params: {
        income: false
      }
    });
    const companyBillingStore = useCompanyBillingStore();
    const expenseSettingStore = useExpenseSettingStore();
    companyBillingStore.alerts = props.alerts;

    // Derived, not stored: cancel() restores `form` wholesale, so anything mirroring
    // it in a sibling field survives the reset and leaves the control out of sync.
    const accountingLevel = computed(() => companyBillingState.form.billClient ? 0 : 1);

    // Matter accounting is entitled. Disabling the option is what reverts a click,
    // since a controlled v-btn-toggle keeps its own selection when the bound value
    // does not change.
    const accountingLevelOptions = computed(() => [{
      label: 'Client Accounting',
      value: 0,
      dataCy: 'accounting-level-client'
    }, {
      label: 'Matter Accounting',
      value: 1,
      dataCy: 'accounting-level-matter',
      disabled: !companyBillingState.me?.features?.matterAccounting
    }]);
    const somethingChanged = computed(() => {
      return JSON.stringify(companyBillingState.form) !== JSON.stringify(originalForm.value);
    });
    const routeService = new RouteService(props);
    companyBillingState.routeService = routeService;

    // Helper function to initialize empty QuickBooks state
    const initializeEmptyQuickBooksState = () => {
      companyBillingState.accounts = [];
      companyBillingState.distributionAccounts = [];
      companyBillingState.accountingServices = {
        services: []
      };
      companyBillingState.taxcodes = [];
    };
    const loadCompanyBillingData = async () => {
      try {
        companyBillingState.loading = true;
        companyBillingState.me = await props.userService.getMe();
        companyBillingState.originalCompany = companyBillingState.me?.company;

        // Check if QuickBooks is enabled and potentially connected before making QB-related API calls
        if (companyBillingState.me?.company?.integration?.quickbooks) {
          // First verify the connection status
          companyBillingState.operatingAccount = await companyBillingStore.verify(false, companyBillingState.me);

          // Check for realm conflict after verification
          if (companyBillingState.operatingAccount?.realmConflict) {
            companyBillingState.openRealmConflictDialog = true;
            companyBillingState.loading = false;
            return; // Stop here and wait for user to resolve the conflict
          }

          // Only make QB API calls if we have a connected account
          if (companyBillingState.operatingAccount?.connected) {
            companyBillingState.accounts = await companyBillingStore.listAccountingAccounts();
            const accountingSettings = await companyBillingStore.getAccountingSettings();
            companyBillingState.distributionAccounts = companyBillingStore.combineQuickBooksAccounts(companyBillingState.accounts, ['asset', 'expense', 'liability', 'income']);
            companyBillingState.accounts = companyBillingState.accounts?.bank?.filter(a => a.subtype != 'TrustAccounts');
            companyBillingState.accountingServices = await companyBillingStore.getAccountingServices();
            if (!companyBillingState.me?.company?.settings?.accountingService) {
              companyBillingState.openWizardDialog = true;
              companyBillingState.params.income = true;
            }
            companyBillingState.taxcodes = await companyBillingStore.listTaxcodes();

            // Set tax information based on QuickBooks accounting settings
            companyBillingState.tax = {
              show: accountingSettings?.salesTaxEnabled && !accountingSettings?.automatedSalesTax,
              loading: false,
              ast: accountingSettings?.automatedSalesTax,
              empty: 'Select a Tax Code'
            };
          } else {
            // QuickBooks is enabled but disconnected - initialize empty arrays
            initializeEmptyQuickBooksState();
            // Set default tax state for disconnected QuickBooks
            companyBillingState.tax = {
              show: false,
              loading: false,
              ast: false,
              empty: 'Select a Tax Code'
            };
          }
        } else {
          // QuickBooks is not enabled - initialize empty state
          companyBillingState.operatingAccount = {
            connected: false
          };
          initializeEmptyQuickBooksState();
          // Set default tax state for no QuickBooks
          companyBillingState.tax = {
            show: false,
            loading: false,
            ast: false,
            empty: 'Select a Tax Code'
          };
        }
        const deactivate = new RouteService(props).rootScopeChange().$on('$stateChangeStart', event => {
          if (somethingChanged.value) {
            companyBillingState.unsaved = true;
            setTimeout(() => {
              companyBillingState.unsaved = false;
            }, 4000);
            event.preventDefault();
          } else {
            deactivate();
          }
        });
        companyBillingState.form = resetForm();
        originalForm.value = JSON.parse(JSON.stringify(companyBillingState.form));
        companyBillingState.loading = false;
      } catch (error) {
        companyBillingState.loading = false;
        props.alerts?.error('Failed to load company billing data');
        console.error('Error loading company billing data:', error);
      }
    };
    onMounted(async () => {
      await loadCompanyBillingData();
    });
    const companyUpdated = async company => {
      companyBillingState.me.company = company;
      companyBillingState.originalCompany = company;

      // Refresh accounting services to include any newly created services
      try {
        companyBillingState.accountingServices = await companyBillingStore.getAccountingServices();
      } catch (error) {
        console.error('Failed to refresh accounting services:', error);
      }
      companyBillingState.form = resetForm();
      originalForm.value = JSON.parse(JSON.stringify(companyBillingState.form));
      companyBillingState.loading = false;
      companyBillingState.unsaved = false;
    };
    const update = async () => {
      companyBillingState.saving = true;
      const updatePayload = {
        settings: {
          clientBilling: {
            billClient: companyBillingState.form.billClient,
            allowChange: companyBillingState.form.allowChange,
            billWithParent: companyBillingState.form.billWithParent
          },
          accountingService: companyBillingState.form.accountingService,
          paymentOptions: companyBillingState.form.paymentOptions ? {
            ...companyBillingState.me?.company?.settings?.paymentOptions
          } : {},
          createAccountingClients: companyBillingState.form.createAccountingClients,
          distribution: {
            method: companyBillingState.form?.distributionMethod?.id,
            account: {
              id: companyBillingState.form.distribution?.id,
              name: companyBillingState.form.distribution?.name
            },
            distributionBillNumber: companyBillingState.form.distributionBillNumber
          },
          tax: {
            services: companyBillingState.form.taxcode || null
          },
          syncClientsFromAccounting: companyBillingState.form?.syncClientsFromAccounting
        }
      };

      // The operating account belongs to Trust Accounting; this page only mirrors it.
      // An empty form value means the account list never loaded, never that the user
      // cleared it (the dropdown is `:clearable="false"`), and an `operating:
      // undefined` serialises away — unassigning the firm's account. So omit trust.
      const operatingAccount = companyBillingState.form.operatingAccount;
      if (operatingAccount?.id) {
        updatePayload.settings.trust = {
          ...companyBillingState.me?.company?.settings?.trust,
          operating: operatingAccount
        };
      }
      try {
        const updatedCompany = await companyBillingStore.updateCompanySettings(updatePayload);
        originalForm.value = JSON.parse(JSON.stringify(companyBillingState.form));
        props.alerts?.success('Settings updated');
        companyUpdated(updatedCompany);
      } catch (error) {
        companyBillingState.saving = false;
        props.alerts?.error('Failed to update settings');
      }
      companyBillingState.unsaved = false;
      companyBillingState.saving = false;
    };
    const cancel = () => {
      companyBillingState.form = JSON.parse(JSON.stringify(originalForm.value));
      companyBillingState.unsaved = false;
    };
    const billClientChange = value => {
      if (value === false && !companyBillingState.me?.features?.matterAccounting) {
        return;
      }
      companyBillingState.form.billClient = value;
    };
    const qboDisconnectDialog = ref(null);
    const disconnectFromQbo = async () => {
      try {
        if (await qboDisconnectDialog.value?.open()) await confirmDisconnect();
      } catch (error) {
        handleError(error);
      }
    };
    const confirmDisconnect = async () => {
      companyBillingState.operatingAccount.connected = false;
      companyBillingState.loading = true;
      try {
        await companyBillingStore.updateCompanySettings({
          integration: {
            quickbooks: false
          }
        });
        companyBillingState.loading = false;
        props.alerts?.success('Disconnected from QuickBooks');
      } catch (error) {
        companyBillingState.loading = false;
        props.alerts?.error('Failed to disconnect from QuickBooks');
      }
    };
    const disconnectFromRealmConflict = async () => {
      companyBillingState.openRealmConflictDialog = false;
      companyBillingState.loading = true;
      try {
        await companyBillingStore.updateCompanySettings({
          integration: {
            quickbooks: false
          }
        });
        // Reset the state to reflect disconnection
        companyBillingState.operatingAccount.connected = false;
        if (companyBillingState.me?.company?.integration) {
          companyBillingState.me.company.integration.quickbooks = false;
        }
        companyBillingState.loading = false;
        props.alerts?.success('Disconnected from QuickBooks');
      } catch (error) {
        companyBillingState.loading = false;
        props.alerts?.error(`Failed to disconnect from QuickBooks: ${error.message || error.response?.data?.message || 'Unknown error'}`);
      }
    };
    const cleanupRealmConflict = async () => {
      companyBillingState.openRealmConflictDialog = false;
      companyBillingState.loading = true;
      try {
        await companyBillingStore.purgeAccounting(props.leanLawApi);
        await props.userService.reset();
        props.alerts?.success('QuickBooks references cleaned up successfully');
        // Reload the component to reflect the changes (equivalent to activate() in Angular)
        await loadCompanyBillingData();

        // After cleanup and reload, check if we need to open the wizard
        // This matches the original Angular logic: if (!company.settings.accountingService) $state.go('.wizard');
        if (!companyBillingState.me?.company?.settings?.accountingService) {
          companyBillingState.openWizardDialog = true;
          companyBillingState.params.income = true;
        }
      } catch (error) {
        companyBillingState.loading = false;
        props.alerts?.error(`Failed to clean up QuickBooks references: ${error.message || error.response?.data?.message || 'Unknown error'}`);
      }
    };
    const enable = sandbox => {
      props.tracking?.event("Started", "QBO Integration", {
        connectToQBClicked: true
      });
      connect(sandbox, props.leanLawAuth);
    };
    const connect = (sandbox, oauth2) => {
      companyBillingState.popup = true;
      const host = props.leanLawAuth.domain !== '' ? props.leanLawAuth.domain : `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
      const url = `${host}/intuit/oauth2?reconnect=true&redirect=${encodeURIComponent(window.location.href)}${sandbox ? '&sandbox=true' : ''}`;
      window.location.href = url;
    };
    const setUpExpenses = () => {
      companyBillingState.openSetUpExpensesDialog = true;
      companyBillingState.openExpenseModal = false;
    };
    const setUpCustomFields = () => {
      routeService.go('settings.company.customFields');
    };
    const importFromQbo = () => {
      routeService.go('settings.company.billing.import');
    };
    const classTracking = () => {
      companyBillingState.showClassTrackingModal = true;
    };
    const nextStep = (title, step) => {
      companyBillingState.currentExpenseSettingsTitle = expenseSettingStore.getCurrentTitleFromStep(step);
    };
    function getSortedArray(items) {
      if (!items || !Array.isArray(items)) {
        return [];
      }
      return items.sort((a, b) => a.name.localeCompare(b.name));
    }

    // The boolean settings default to false rather than passing undefined through.
    // originalForm is a JSON round-trip of this, and JSON.stringify drops undefined
    // keys — so a setting a firm has never touched would be absent from the
    // baseline, and somethingChanged could never return to false once its control
    // had been touched and returned to off.
    function resetForm() {
      companyBillingState.form.distribution = {
        method: companyBillingState.form?.distributionMethod?.id,
        account: {
          id: companyBillingState.form.distribution?.id,
          name: companyBillingState.form.distribution?.name
        },
        distributionBillNumber: companyBillingState.form.distributionBillNumber
      };
      return {
        billClient: companyBillingState.me?.company?.settings?.clientBilling?.billClient ?? true,
        accountingService: companyBillingState.accountingServices?.services?.find(s => s.id === companyBillingState.me?.company?.settings?.accountingService?.id),
        operatingAccount: companyBillingState.accounts?.find(account => account.id === companyBillingState.me?.company?.settings?.trust?.operating?.id),
        clientBilling: companyBillingState.me?.company?.settings?.clientBilling,
        createAccountingClients: companyBillingState.me?.company?.settings?.createAccountingClients ?? false,
        distribution: companyBillingState.distributionAccounts.find(distributionAccount => distributionAccount.id == companyBillingState.me?.company?.settings?.distribution?.account.id),
        paymentOptions: companyBillingState.me?.company?.settings?.paymentOptions,
        taxcode: companyBillingState.taxcodes.find(t => t.id === companyBillingState.me?.company?.settings?.tax?.services?.id),
        allowChange: companyBillingState.me?.company?.settings?.clientBilling?.allowChange ?? false,
        billWithParent: companyBillingState.me?.company?.settings?.clientBilling?.billWithParent ?? false,
        syncClientsFromAccounting: companyBillingState.me?.company?.settings?.syncClientsFromAccounting ?? false,
        distributionBillNumber: companyBillingState.me?.company?.settings?.distribution?.distributionBillNumber ?? false,
        allowChangeValue: companyBillingState.me?.company?.settings?.clientBilling?.allowChange ?? false,
        distributionMethod: companyBillingState.me?.company?.settings?.distribution?.method ? companyBillingState.distributionMethod.find(d => d.id === companyBillingState.me?.company?.settings?.distribution?.method) : null
      };
    }
    return (_ctx, _cache) => {
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_container = _resolveComponent("v-container");
      return companyBillingState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Quickbooks Integration',
        class: "mt-32"
      })) : (_openBlock(), _createBlock(_component_v_container, {
        key: 1,
        class: "w-full pa-8"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createVNode(_component_v_col, {
            class: "pa-0",
            cols: "12"
          }, {
            default: _withCtx(() => [_createVNode(MainHeader, {
              content: 'QuickBooks Integration'
            })]),
            _: 1
          }), companyBillingState.me?.company?.integration?.quickbooks && !companyBillingState.operatingAccount?.connected || !companyBillingState.me?.company?.integration?.quickbooks ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0
          }, {
            default: _withCtx(() => [companyBillingState.me?.company?.integration?.quickbooks && !companyBillingState.operatingAccount?.connected ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, null, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createElementVNode("p", null, " You have QuickBooks enabled for the firm, but it has been disconnected... ", -1)]))]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, {
              class: "pl-5"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "12",
                class: "pb-4"
              }, {
                default: _withCtx(() => [_createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = () => enable(false))
                }, [...(_cache[30] || (_cache[30] = [_createElementVNode("img", {
                  src: "/img/qbconnect.png",
                  width: "200"
                }, null, -1)]))])]),
                _: 1
              }), companyBillingState.me?.company?.status == 'test' || companyBillingState.me?.company?.status == 'internal' ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                class: "py-2"
              }, {
                default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("div", {
                  class: "text-body-2 mb-2"
                }, "... or", -1)), _createVNode(LlSecondaryButton, {
                  variant: "outlined",
                  onClick: _cache[1] || (_cache[1] = () => enable(true))
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode(" Connect to Sandbox ", -1)]))]),
                  _: 1
                })]),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_v_col, {
                cols: "12",
                class: "py-2"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(LlSecondaryButton, {
                  color: "error",
                  variant: "elevated",
                  width: "200",
                  height: "40",
                  onClick: _cache[2] || (_cache[2] = () => _ctx.disable(true)),
                  disabled: companyBillingState.saving,
                  loading: companyBillingState.saving
                }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode(" Disable QuickBooks ", -1)]))]),
                  _: 1
                }, 8, ["disabled", "loading"]), _createVNode(LlTooltip, {
                  icon: "help",
                  class: "flex-shrink-0"
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode(" This disables QuickBooks from your account so that you won't get any more warnings. You can reconnect later. ", -1)]))]),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            })])) : _createCommentVNode("", true), !companyBillingState.me?.company?.integration?.quickbooks ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_v_row, {
              class: "pl-5"
            }, {
              default: _withCtx(() => [_createElementVNode("p", null, [_createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = () => enable(false))
              }, [...(_cache[35] || (_cache[35] = [_createElementVNode("img", {
                src: "/img/qbconnect.png",
                width: "170"
              }, null, -1)]))])])]),
              _: 1
            }), _createVNode(_component_v_row, {
              class: "pl-5 mb-5"
            }, {
              default: _withCtx(() => [companyBillingState.me?.company?.status == 'test' || companyBillingState.me?.company?.status == 'internal' ? (_openBlock(), _createElementBlock("p", _hoisted_4, [_cache[37] || (_cache[37] = _createTextVNode(" ... or ", -1)), _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)), _createVNode(LlSecondaryButton, {
                variant: "outlined",
                onClick: _cache[4] || (_cache[4] = () => enable(true))
              }, {
                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode(" Connect to Sandbox ", -1)]))]),
                _: 1
              })])) : _createCommentVNode("", true)]),
              _: 1
            }), companyBillingState.popup ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[39] || (_cache[39] = [_createElementVNode("h3", null, "Follow instructions in the QuickBooks popup window.", -1), _createElementVNode("p", null, " If no popup appear, disable your popup blocker and try again. ", -1)]))])) : _createCommentVNode("", true), _cache[41] || (_cache[41] = _createElementVNode("p", null, " LeanLaw was built with QuickBooks integration in mind. Our integration approach is to have your accounting data live entirely in QuickBooks and have a live connection to any data needed by LeanLaw. There is no “sync”, the data is just available and always up-to-date. ", -1)), _cache[42] || (_cache[42] = _createElementVNode("p", null, " You can try out LeanLaw without connecting QuickBooks, but our solution requires a QuickBooks Online account to create invoices and to manage trust accounts. Draft invoices can be created and printed without QuickBooks. ", -1)), _cache[43] || (_cache[43] = _createElementVNode("p", null, "Read more about how we integrate with QuickBooks here:", -1)), _createVNode(LlSecondaryButton, {
              variant: "outlined",
              href: qboIntegrationUrl.value,
              target: "_blank",
              rel: "noopener noreferrer",
              "prepend-icon": "mdi-open-in-new"
            }, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode(" LeanLaw and QuickBooks ", -1)]))]),
              _: 1
            }, 8, ["href"])])) : _createCommentVNode("", true)]),
            _: 1
          })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_v_col, {
            class: "pa-0",
            cols: "12"
          }, {
            default: _withCtx(() => [companyBillingState.operatingAccount?.connected ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("p", null, [_cache[44] || (_cache[44] = _createTextVNode(" LeanLaw is connected to this QuickBooks company: ", -1)), _createElementVNode("b", null, _toDisplayString(companyBillingState.operatingAccount?.companyName), 1)])])) : _createCommentVNode("", true), _createVNode(_component_v_row, {
              class: "pa-0 align-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2 d-flex align-center"
                }, {
                  default: _withCtx(() => [_cache[46] || (_cache[46] = _createTextVNode("Default QuickBooks Service ", -1)), _createElementVNode("span", _hoisted_7, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [_createTextVNode("Invoice line items are assigned a QuickBooks Product/Service. Typically you will use \"Services\" or \"Legal Services\" here.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlSelect, {
                    items: getSortedArray(companyBillingState.accountingServices?.services),
                    modelValue: companyBillingState.form.accountingService,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => companyBillingState.form.accountingService = $event),
                    "item-value": 'id',
                    "item-title": item => item?.name,
                    "return-object": true,
                    clearable: true,
                    "is-autocomplete": true,
                    placeholder: "QuickBooks Product/Service",
                    "hide-details": true,
                    class: "w-full"
                  }, null, 8, ["items", "modelValue", "item-title"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, {
              class: "pa-0 align-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2 d-flex align-center"
                }, {
                  default: _withCtx(() => [_cache[48] || (_cache[48] = _createTextVNode("Expenses ", -1)), _createElementVNode("span", _hoisted_8, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [_createTextVNode(" Set up how expenses are mapped to QuickBooks accounts and product/service settings. ", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_withDirectives(_createVNode(LlSecondaryButton, {
                    class: "mr-2",
                    onBtnClick: _cache[6] || (_cache[6] = $event => setUpExpenses())
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode(" Set up Expenses ", -1)]))]),
                    _: 1
                  }, 512), [[_vShow, !companyBillingState.me?.company?.settings?.expenses?.accountingService]]), _withDirectives(_createVNode(LlSecondaryButton, {
                    onBtnClick: _cache[7] || (_cache[7] = $event => setUpExpenses())
                  }, {
                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [_createElementVNode("img", {
                      src: "/img/qb16x16.png",
                      style: {
                        "margin-right": "10px",
                        "height": "16px",
                        "width": "16px"
                      }
                    }, null, -1), _createTextVNode("Edit Expense Settings ", -1)]))]),
                    _: 1
                  }, 512), [[_vShow, companyBillingState.me?.company?.settings?.expenses?.accountingService]])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, {
              class: "align-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2 d-flex align-center"
                }, {
                  default: _withCtx(() => [_cache[53] || (_cache[53] = _createTextVNode("Operating Account ", -1)), _createElementVNode("span", _hoisted_9, [_withDirectives(_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [_createTextVNode("This is required to record invoice payments from LeanLaw", -1)]))]),
                    _: 1
                  }, 512), [[_vShow, !companyBillingState.me?.company?.settings?.trustEnabled]]), _withDirectives(_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode("This is required to record invoice payments from LeanLaw. It is configured in your trust account settings. To change it go to Trust Accounting", -1)]))]),
                    _: 1
                  }, 512), [[_vShow, companyBillingState.me?.company?.settings?.trustEnabled]])])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlSelect, {
                    items: companyBillingState.accounts,
                    modelValue: companyBillingState.form.operatingAccount,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => companyBillingState.form.operatingAccount = $event),
                    "item-value": 'id',
                    "item-title": 'name',
                    "return-object": true,
                    clearable: false,
                    "is-autocomplete": true,
                    placeholder: "Select Operating Account",
                    "hide-details": true,
                    class: "w-full"
                  }, null, 8, ["items", "modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), !companyBillingState.tax?.show ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              class: "align-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2 d-flex align-center"
                }, {
                  default: _withCtx(() => [...(_cache[54] || (_cache[54] = [_createTextVNode("Tax", -1)]))]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [companyBillingState.tax?.loading ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "16",
                    class: "mr-2"
                  }), _cache[55] || (_cache[55] = _createElementVNode("span", null, "Loading...", -1))])) : companyBillingState.tax?.ast ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[57] || (_cache[57] = _createElementVNode("em", null, "Automated Sales Tax", -1)), _createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode(" Your QuickBooks account is configured with Automated Sales Tax. Tax is determined by a combination of product/service settings and client settings in QuickBooks. ", -1)]))]),
                    _: 1
                  })])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_cache[59] || (_cache[59] = _createElementVNode("em", null, "Sales Tax Not Enabled", -1)), _createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [_createTextVNode(" Your QuickBooks account does not have sales tax turned on so sales tax will not be applied to invoices. To turn it on go to the Tax section in QuickBooks. ", -1)]))]),
                    _: 1
                  })]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), companyBillingState.tax?.show ? (_openBlock(), _createBlock(_component_v_row, {
              key: 2,
              class: "align-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2 d-flex align-center"
                }, {
                  default: _withCtx(() => [_cache[61] || (_cache[61] = _createTextVNode(" Default Tax Code ", -1)), _createElementVNode("span", _hoisted_13, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[60] || (_cache[60] = [_createTextVNode(" This must be set to apply tax to invoices. When creating invoices, sales tax is determined by whether the product/service and client is taxable. If they are, the default tax code of the client (in QuickBooks) will be used, if not this default tax code will be used ", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlSelect, {
                    items: companyBillingState.taxcodes,
                    modelValue: companyBillingState.form.taxcode,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => companyBillingState.form.taxcode = $event),
                    "item-value": 'id',
                    "item-title": 'name',
                    "return-object": true,
                    clearable: true,
                    "is-autocomplete": true,
                    placeholder: companyBillingState.tax?.empty || 'Select a Tax Code',
                    "hide-details": true,
                    class: "w-full"
                  }, null, 8, ["items", "modelValue", "placeholder"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_v_row, {
              class: "accounting-types"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(companyBillingState.form.allowChange ? 'Default type of Accounting' : 'Type of Accounting') + " ", 1), _createElementVNode("span", _hoisted_14, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode("This determines whether invoices and trust accounts are handled in QuickBooks. Client-level accounting puts everything under the client, matter-level accounting creates sub-customer in QuickBooks under each client and puts everything under there. This is a premium feature.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "pa-4 flex flex-col"
                }, {
                  default: _withCtx(() => [_createVNode(LlButtonToggle, {
                    "model-value": accountingLevel.value,
                    items: accountingLevelOptions.value,
                    "aria-label": "Accounting level",
                    "data-cy": "accounting-level-toggle",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => billClientChange($event === 0))
                  }, null, 8, ["model-value", "items"]), !companyBillingState.me?.features?.matterAccounting ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(ProductNotice, {
                    state: __props.state,
                    label: 'The Matter Accounting option is',
                    trial: true,
                    product: 'matterAccounting'
                  }, null, 8, ["state"])])) : _createCommentVNode("", true)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), companyBillingState.form.allowChangeValue ? (_openBlock(), _createBlock(_component_v_row, {
              key: 3
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[64] || (_cache[64] = _createTextVNode("Ask about Client or Matter Level Billing ", -1)), _createElementVNode("span", _hoisted_16, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [_createTextVNode("If enabled, you will be asked whether accounting should be done at the client level or matter level, the first time an invoice is created for that client.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlCheckbox, {
                    modelValue: companyBillingState.form.allowChange,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => companyBillingState.form.allowChange = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), companyBillingState.me?.features?.matterAccounting ? (_openBlock(), _createBlock(_component_v_row, {
              key: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[66] || (_cache[66] = _createTextVNode("Matters Marked \"Bill with Parent\" ", -1)), _createElementVNode("span", _hoisted_17, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode("If set, the QuickBooks setting 'Bill with Parent' will be set for any matters created, the default is to set 'Bill with Customer'. If you are not sure, leave this setting off.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlCheckbox, {
                    modelValue: companyBillingState.form.billWithParent,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => companyBillingState.form.billWithParent = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[68] || (_cache[68] = _createTextVNode("Create Client/Matter Right Away in QuickBooks ", -1)), _createElementVNode("span", _hoisted_18, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[67] || (_cache[67] = [_createTextVNode("If enabled, clients and matters will be created in QuickBooks as soon as they are created in LeanLaw. If not enabled, clients won't be created until necessary for example when creating an invoice or doing a trust deposit, or when connected manually.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlCheckbox, {
                    modelValue: companyBillingState.form.createAccountingClients,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => companyBillingState.form.createAccountingClients = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), companyBillingState.me?.features?.clientFromQuickBooks ? (_openBlock(), _createBlock(_component_v_row, {
              key: 5
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[70] || (_cache[70] = _createTextVNode(" Sync Clients from QuickBooks ", -1)), _createElementVNode("span", _hoisted_19, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[69] || (_cache[69] = [_createTextVNode("If enabled, clients created in QuickBooks directly are automatically sync'd to LeanLaw.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "pa-4 flex-col"
                }, {
                  default: _withCtx(() => [_createVNode(LlCheckbox, {
                    modelValue: companyBillingState.form.syncClientsFromAccounting,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => companyBillingState.form.syncClientsFromAccounting = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), originalForm.value?.paymentOptions?.creditCard || originalForm.value?.paymentOptions?.ach ? (_openBlock(), _createBlock(_component_v_row, {
              key: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[72] || (_cache[72] = _createTextVNode("Invoice Payment Methods ", -1)), _createElementVNode("span", _hoisted_20, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[71] || (_cache[71] = [_createTextVNode("The default payment methods applied to invoices (must be set up in QuickBooks to work correctly)", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "pa-4 flex-col"
                }, {
                  default: _withCtx(() => [companyBillingState.form?.paymentOptions?.creditCard ? (_openBlock(), _createBlock(LlCheckbox, {
                    key: 0,
                    modelValue: companyBillingState.form.paymentOptions.creditCard,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => companyBillingState.form.paymentOptions.creditCard = $event),
                    label: "Online Credit Card"
                  }, null, 8, ["modelValue"])) : _createCommentVNode("", true), companyBillingState.form?.paymentOptions?.ach ? (_openBlock(), _createBlock(LlCheckbox, {
                    key: 1,
                    modelValue: companyBillingState.form.paymentOptions.ach,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => companyBillingState.form.paymentOptions.ach = $event),
                    label: "Online ACH"
                  }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[74] || (_cache[74] = _createTextVNode("Class Tracking ", -1)), _createElementVNode("span", _hoisted_21, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[73] || (_cache[73] = [_createTextVNode("You can optionally track invoices or invoice line items to classes for the users in the firm", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(ProductNotice, {
                    state: __props.state,
                    label: 'Using class tracking with QuickBooks Online is',
                    product: 'classTracking'
                  }, null, 8, ["state"]), companyBillingState.me?.features?.classTracking ? (_openBlock(), _createElementBlock("div", _hoisted_22, [companyBillingState.me?.company?.settings?.tags?.enabled ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Class tracking is enabled ")) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
                    onBtnClick: classTracking
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(companyBillingState.me?.company?.settings?.tags?.enabled ? 'Edit' : 'Set Up') + " Class Tracking ", 1)]),
                    _: 1
                  })])) : _createCommentVNode("", true)]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[76] || (_cache[76] = _createTextVNode("Distribution Method ", -1)), _createElementVNode("span", _hoisted_24, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[75] || (_cache[75] = [_createTextVNode("Selecting the 'QuickBooks Bill for Vendor' option means we will create users as a 'Vendor' in QuickBooks and create a QuickBooks Bill to execute the distribution.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlSelect, {
                    items: companyBillingState.distributionMethod,
                    modelValue: companyBillingState.form.distributionMethod,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => companyBillingState.form.distributionMethod = $event),
                    "item-title": 'label',
                    "item-value": 'id',
                    "return-object": true,
                    clearable: true,
                    "is-autocomplete": true,
                    placeholder: "Select Distribution Method",
                    "hide-details": true,
                    class: "w-full"
                  }, null, 8, ["items", "modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[78] || (_cache[78] = _createTextVNode("Distribution QuickBooks Category ", -1)), _createElementVNode("span", _hoisted_25, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[77] || (_cache[77] = [_createTextVNode("Distribution payments are assigned a 'Category'. Select a QuickBooks account to be used as the 'Category'.", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlSelect, {
                    items: companyBillingState.distributionAccounts,
                    modelValue: companyBillingState.form.distribution,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => companyBillingState.form.distribution = $event),
                    "item-title": 'label',
                    "item-value": 'id',
                    disabled: !companyBillingState.form.distributionMethod,
                    "return-object": true,
                    clearable: true,
                    "is-autocomplete": true,
                    placeholder: "Select Distribution QuickBooks Category",
                    "hide-details": true,
                    class: "w-full"
                  }, null, 8, ["items", "modelValue", "disabled"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[80] || (_cache[80] = _createTextVNode("Distribution Bill Number ", -1)), _createElementVNode("span", _hoisted_26, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[79] || (_cache[79] = [_createTextVNode("If enabled, Distribution bills will be created with a bill number of DIS MM/DD/YY HH:MM:SS (a timestamp of when the bill was created).", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlCheckbox, {
                    modelValue: companyBillingState.form.distributionBillNumber,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => companyBillingState.form.distributionBillNumber = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _withDirectives(_createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[82] || (_cache[82] = _createTextVNode("Custom Fields ", -1)), _createElementVNode("span", _hoisted_27, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[81] || (_cache[81] = [_createTextVNode("Choose which LeanLaw fields are sent to QuickBooks and where they appear", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                    onBtnClick: setUpCustomFields
                  }, {
                    default: _withCtx(() => [...(_cache[83] || (_cache[83] = [_createTextVNode(" Set Up Custom Fields ", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 512), [[_vShow, companyBillingState.me?.company?.integration?.quickbooks && companyBillingState.operatingAccount?.connected]]), _withDirectives(_createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_cache[85] || (_cache[85] = _createTextVNode("Client Import ", -1)), _createElementVNode("span", _hoisted_28, [_createVNode(LlTooltip, {
                    icon: "help",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[84] || (_cache[84] = [_createTextVNode("Bring your existing QuickBooks customers into LeanLaw as clients", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_col, {
                class: "pa-0",
                cols: "6"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                    onBtnClick: importFromQbo
                  }, {
                    default: _withCtx(() => [...(_cache[86] || (_cache[86] = [_createTextVNode(" Import Clients ", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 512), [[_vShow, companyBillingState.me?.company?.integration?.quickbooks && companyBillingState.operatingAccount?.connected]]), _withDirectives(_createVNode(_component_v_row, null, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                class: "pa-0",
                cols: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_card_text, {
                  class: "py-2"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_cache[88] || (_cache[88] = _createElementVNode("div", {
                    class: "flex-grow-1 mr-4"
                  }, [_createElementVNode("div", {
                    class: "font-weight-medium text-error"
                  }, " Disconnect from QuickBooks "), _createElementVNode("div", {
                    class: "text-sm text-grey-darken-1"
                  }, " Stops all syncing to and from QuickBooks Online. You can reconnect later. ")], -1)), _createVNode(LlSecondaryButton, {
                    color: "error",
                    onBtnClick: disconnectFromQbo
                  }, {
                    default: _withCtx(() => [...(_cache[87] || (_cache[87] = [_createTextVNode(" Disconnect ", -1)]))]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 512), [[_vShow, companyBillingState.me?.company?.integration?.quickbooks && companyBillingState.operatingAccount?.connected]])]),
            _: 1
          }, 512), [[_vShow, companyBillingState.me?.company?.integration?.quickbooks && companyBillingState.operatingAccount?.connected]])]),
          _: 1
        }), _withDirectives(_createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createVNode(SettingsSaveBar, {
            somethingChanged: somethingChanged.value,
            saving: companyBillingState.saving,
            unsaved: companyBillingState.unsaved,
            onUpdate: update,
            onCancel: cancel
          }, null, 8, ["somethingChanged", "saving", "unsaved"])]),
          _: 1
        }, 512), [[_vShow, companyBillingState.me?.company?.integration?.quickbooks && companyBillingState.operatingAccount?.connected]]), _createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createVNode(LlConfirmationDialog, {
            ref_key: "qboDisconnectDialog",
            ref: qboDisconnectDialog,
            title: "Disconnect from QuickBooks",
            message: "Are you sure about this? This affects all users in the firm. It is strongly recommended that you leave QuickBooks connected to allow LeanLaw to communicate with your QuickBooks account.",
            "toggle-text": "Cancel",
            "confirm-text": "Ok",
            "max-width": 800,
            "data-cy": "qbo-disconnect-dialog"
          }, null, 512)]),
          _: 1
        }), _createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createVNode(_component_v_dialog, {
            modelValue: companyBillingState.openRealmConflictDialog,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => companyBillingState.openRealmConflictDialog = $event),
            width: "700",
            persistent: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card, {
              class: "min-h-[400px]"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_card_title, {
                class: "d-flex justify-space-between align-center pa-6"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_v_icon, {
                  color: "warning",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[89] || (_cache[89] = [_createTextVNode("mdi-alert", -1)]))]),
                  _: 1
                }), _cache[90] || (_cache[90] = _createElementVNode("span", {
                  class: "text-h6 text-gray-500 border-b-2 border-green-regular pb-0.5"
                }, " Important - Please Read! ", -1))])]),
                _: 1
              }), _createVNode(_component_v_card_text, {
                class: "pa-4"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_alert, {
                  type: "warning",
                  icon: "mdi-alert",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [...(_cache[91] || (_cache[91] = [_createElementVNode("strong", null, "QuickBooks Account Mismatch Detected", -1)]))]),
                  _: 1
                }), _cache[92] || (_cache[92] = _createElementVNode("div", {
                  class: "mb-4"
                }, [_createElementVNode("p", {
                  class: "mb-3"
                }, " You are connected to QuickBooks, but this LeanLaw account was previously connected to a different QuickBooks account. "), _createElementVNode("p", {
                  class: "mb-3"
                }, "We need to either:"), _createElementVNode("ul", {
                  class: "list-none mb-3"
                }, [_createElementVNode("li", {
                  class: "mb-2"
                }, [_createElementVNode("strong", null, "Disconnect"), _createTextVNode(" from the new QuickBooks (if you need to connect back to the old account)")]), _createElementVNode("li", {
                  class: "mb-2"
                }, [_createElementVNode("strong", null, "Clean up"), _createTextVNode(" all references to the old QuickBooks account. This cannot be undone!")])]), _createElementVNode("p", {
                  class: "mb-0"
                }, " If you don't know what this means, click 'Disconnect' and contact LeanLaw support. ")], -1))]),
                _: 1
              }), _createVNode(_component_v_card_actions, {
                class: "pa-4"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
                  variant: "outlined",
                  onClick: _cache[20] || (_cache[20] = $event => disconnectFromRealmConflict())
                }, {
                  default: _withCtx(() => [...(_cache[93] || (_cache[93] = [_createTextVNode(" Disconnect ", -1)]))]),
                  _: 1
                }), _createVNode(LlSecondaryButton, {
                  color: "primary",
                  variant: "elevated",
                  onClick: _cache[21] || (_cache[21] = $event => cleanupRealmConflict())
                }, {
                  default: _withCtx(() => [...(_cache[94] || (_cache[94] = [_createTextVNode(" Clean up ", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createVNode(_component_v_dialog, {
            modelValue: companyBillingState.openSetUpExpensesDialog,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => companyBillingState.openSetUpExpensesDialog = $event),
            width: "720",
            scrollable: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card, null, {
              default: _withCtx(() => [_createVNode(_component_v_card_title, {
                class: "d-flex justify-space-between align-center pa-2"
              }, {
                default: _withCtx(() => [_cache[95] || (_cache[95] = _createElementVNode("div", null, [_createElementVNode("span", {
                  class: "text-h6 text-gray-500 border-b-2 border-green-regular pb-0.5"
                }, " Expense Configuration ")], -1)), _createVNode(LlSecondaryButton, {
                  icon: "mdi-close",
                  variant: "text",
                  size: "small",
                  "aria-label": "Close",
                  onClick: _cache[23] || (_cache[23] = $event => companyBillingState.openSetUpExpensesDialog = false)
                })]),
                _: 1
              }), _createVNode(_component_v_card_text, {
                class: "pa-0 overflow-auto"
              }, {
                default: _withCtx(() => [_createVNode(SetUpExpensesDialogs, {
                  userService: __props.userService,
                  accountingService: __props.accountingService,
                  companyBillingState: companyBillingState,
                  tracking: __props.tracking,
                  routeService: _unref(routeService),
                  stateParams: __props.stateParams,
                  alerts: __props.alerts
                }, null, 8, ["userService", "accountingService", "companyBillingState", "tracking", "routeService", "stateParams", "alerts"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        }), companyBillingState.me.company?.integration?.quickbooks ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_component_v_dialog, {
            modelValue: companyBillingState.openWizardDialog,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => companyBillingState.openWizardDialog = $event),
            width: "700",
            scrollable: ""
          }, {
            default: _withCtx(() => [_createVNode(Wizard, {
              userService: __props.userService,
              accountingService: __props.accountingService,
              companyBillingState: companyBillingState,
              stateParams: __props.stateParams,
              alerts: __props.alerts,
              onNext: nextStep,
              onUpdateCompany: companyUpdated,
              onCloseDialog: _cache[25] || (_cache[25] = $event => companyBillingState.openWizardDialog = false)
            }, null, 8, ["userService", "accountingService", "companyBillingState", "stateParams", "alerts"])]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_v_dialog, {
          modelValue: companyBillingState.showClassTrackingModal,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => companyBillingState.showClassTrackingModal = $event),
          width: "600",
          persistent: ""
        }, {
          default: _withCtx(() => [_createVNode(ClassTrackingSetup, {
            company: companyBillingState.me?.company,
            userService: __props.userService,
            leanLawApi: __props.leanLawApi,
            alerts: __props.alerts,
            state: __props.state,
            stateParams: __props.stateParams,
            rootScope: __props.rootScope,
            lists: _ctx.lists,
            onClose: _cache[27] || (_cache[27] = $event => companyBillingState.showClassTrackingModal = false)
          }, null, 8, ["company", "userService", "leanLawApi", "alerts", "state", "stateParams", "rootScope", "lists"])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }));
    };
  }
});